<!-- echarts 雷达图-->
<template>
  <div class="echarts_wrap">
    <div class="title">{{ el.title }}</div>
    <div class="content_wrap">
      <div class="left">
        <div class="basic-radar" ref="wrapper"></div>
        <div v-if="el.title == '优势与兴趣匹配分析'" class="pic_tip">
          <div><span class="red">1、红色</span>代表兴趣</div>
          <div><span class="blue">2、蓝色</span>代表优势</div>
        </div>
      </div>

      <ul v-if="el.desc && el.desc.contents.length > 0">
        <li v-for="(item, index) in el.desc.contents" :key="index">
          {{ item }}
        </li>
      </ul>
      <div class="right" v-if="el.rightPic">
        <basic-line :info="el.rightPic.data" :el="el.rightPic"></basic-line>
        <div v-if="el.title == '优势与兴趣匹配分析'" class="pic_tip">
          <div><span class="red">1、红色</span>代表兴趣</div>
          <div><span class="blue">2、蓝色</span>代表优势</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import basicLine from "@/components/echarts/line/index";
export default {
  components: {
    basicLine
  },
  data() {
    return {
      chart: null,
      option: null
    };
  },
  props: {
    info: {
      type: Object,
      default: null
    },
    el: {
      type: Object,
      default: null
    }
  },
  mounted() {
    // console.log("雷达图数据", this.el);
  },
  methods: {
    init() {
      let wrapper = this.$refs["wrapper"];
      this.chart = this.$echarts.init(wrapper);
    },
    // 过滤数据
    filterData(data) {
      return data;
    },
    // 设置数据
    setData(data) {
      this.option = data;
      this.$nextTick(() => {
        this.init();
        setTimeout(() => {
          this.draw(data);
        }, 300);
      });
    },
    draw(data) {
      if (data && this.chart && "function" == typeof this.chart.setOption) {
        this.chart.clear();
        this.chart.setOption(data);

        window.addEventListener("resize", () => {
          this.chart.resize();
        });
      }
    }
  },
  watch: {
    info: {
      immediate: true,
      handler: function(val, oldVal) {
        if (!val) {
          return false;
        }
        
        let data = this.filterData(val);
        this.setData(data);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.echarts_wrap {
  .title {
    height: 0.84rem;
    background: #57d0ac;
    border-radius: 0 0 70px 70px;
    line-height: 0.84rem;
    text-align: center;
    font-size: 0.3rem;
    font-weight: 600;
    color: #fff;
  }
  .content_wrap {
    width: 100%;
    .left,
    .right {
      width: 100%;
    }
  }
  .basic-radar {
    width: 100% !important;
    background: #fff;
    height: 410px;
    padding: 20px 0 0 0;
    // border: 2px solid #57b4d0;
  }
  .red {
    color: #a70008;
  }
  .blue {
    color: #0821a2;
  }
  .pic_tip {
    line-height: 24px;
    padding:0 10px 10px;
  }
  ul {
    width: 100%;
    border: 2px solid #ccc;
    min-height: 300px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    li {
      padding: 10px;
      width: 100%;
      border-bottom: 2px solid #ccc;
      &:last-child {
        border-bottom: none;
      }
    }
  }
}
</style>
